export const DirectSellApi = 'wx/directsellprod' // 配件列表
export const DirectSellFavorites = 'wx/directsellfavorites/' // 收藏夹
export const DirectSellOrderApi = 'wx/directsellorder/' // 配件订单
